<template>
  <v-simple-table dense>
    <thead>
      <tr>
        <th>ID</th>
        <th>Nombre Compuesto</th>
        <th>Sede</th>
        <th class="text-center">Otro Cod. Académico</th>
        <th class="text-right">Cantidad Inscritos</th>
      </tr>
    </thead>

    <tbody>
      <tr v-if="cargando">
        <td colspan="5" class="text-center">
          <v-progress-circular indeterminate color="primary" size="20"></v-progress-circular>
        </td>
      </tr>

      <tr v-else-if="datos.length === 0">
        <td colspan="5" class="text-center">No hay datos de inscritos para este programa.</td>
      </tr>

      <template v-else>
        <tr v-for="dato in datos" :key="dato.id">
          <td>{{ dato.id }}</td>
          <td class="text-truncate">{{ dato.nombreCompuesto }}</td>
          <td>{{ dato.sedeNombre }}</td>
          <td
            class="text-center"
            title="El programa tiene inscritos de otro programa universidad distinto al vinculado en esta consulta.">
            {{ dato.otroCodigoAcademico ? 'Sí' : 'No' }}
          </td>
          <td class="text-right">{{ dato.cantidadInscritos }}</td>
        </tr>

        <tr>
          <td colspan="3" class="text-right font-weight-bold">Total Cantidad Inscritos</td>
          <td></td>
          <td class="text-right font-weight-bold">{{ total }}</td>
        </tr>
      </template>
    </tbody>
  </v-simple-table>
</template>

<script>
import ProgramaUniversidadService from '../services/programa-universidad.service';

export default {
  name: 'TablaCantidadInscritosPrograma',
  data() {
    return {
      datos: [],
      cargando: false,
    };
  },
  computed: {
    total() {
      return this.datos.reduce((total, dato) => total + Number(dato.cantidadInscritos), 0);
    },
  },
  methods: {
    cargar(programaUniversidadId) {
      this.datos = [];
      this.cargando = true;

      return ProgramaUniversidadService.cantidadInscritos({ params: { programaUniversidadId } })
        .then((response) => {
          this.datos = response?.data?.datos || [];
        })
        .finally(() => {
          this.cargando = false;
        });
    },
  },
};
</script>
